import { defineMessages } from 'react-intl';

export const multiStepFormMessages = defineMessages({
  buttonPreview: {
    defaultMessage: 'Weiter zur Vorschau',
    id: 'customerReviews.addReview.multiStepForm.button.preview',
  },
  buttonEdit: {
    defaultMessage: 'Bewertung bearbeiten',
    id: 'customerReviews.addReview.multiStepForm.button.edit',
  },
  buttonSubmit: {
    defaultMessage: 'Bewertung abgeben',
    id: 'customerReviews.addReview.multiStepForm.button.submit',
  },
});
